import { createContext, useContext } from "react";
import { useAppContext } from "./AppContext";
import { useFetch } from "../hooks/useFetch";
import {
  get_xflow_partners,
  get_xflow_receivables_fee_plans,
} from "../constants/apis";
import { XFlowFeePlansRes } from "../types/XFlow";

type FeePlans = {
  data: XFlowFeePlansRes | null;
  loading: boolean;
  refetch: () => void;
};

const XFlowFeePlansContext = createContext<FeePlans | null>(null);

export const XFlowFeePlansContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { jwtToken } = useAppContext();

  const { data, loading, refetch } = useFetch<XFlowFeePlansRes>(
    get_xflow_receivables_fee_plans,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
  );

  return (
    <XFlowFeePlansContext.Provider value={{ data, loading, refetch }}>
      {children}
    </XFlowFeePlansContext.Provider>
  );
};

export const useXFlowFeePlansContext = () => {
  const context = useContext(XFlowFeePlansContext);

  if (!context) throw new Error("Context must be used within an provider");

  return context;
};
